export const isProxyAvailable =
  // @ts-ignore - ProxyPolyfilled will be set in the services
  typeof window !== 'undefined' && !window.ProxyPolyfilled
